module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_hospital04-e43d2ed2a2ee2ab8beabf2f272fae16d.png";